import './../app/shared/operators';

import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as u from '../actions/universe.actions';

import { Api } from '../providers/api/api';

@Injectable()
export class UniverseEffects {
  constructor(private actions$: Actions,
    private api: Api
  ) {
  }

  @Effect()
  addCompany$: Observable<Action> = this.actions$
  .ofType(u.ADD_COMPANY)
  .map((action: u.AddCompany) => {
    return action.payload;
  })
  .switchMap((payload) => this.api.addUniverseCompany(payload))
  .map(user => {
    return new u.AddUniverseCompanySuccess();
  }).catch((err) => of(new u.AddUniverseCompanyFailure()));


  @Effect()
  FetchUniverseCompanies$: Observable<Action> = this.actions$
    .ofType(u.FETCH)
    .map((action: u.Fetch) => {
      return action;
    })
    .switchMap((filter: object) => this.api.getUniverseCompanies())
    .map(companies => {
      return new u.FetchSuccess(companies)
    }
    );

}



// WEBPACK FOOTER //
// ./src/effects/universe.effects.ts